import React, { useEffect, useState, useCallback } from 'react';
import './NotificationToast.css';

/**
 * Toast notification component for showing new FNOL alerts
 * Similar to WhatsApp's notification banner
 */
const NotificationToast = ({ notification, onClose, duration = 5000 }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLeaving, setIsLeaving] = useState(false);

  const handleClose = useCallback(() => {
    setIsLeaving(true);
    setTimeout(() => {
      setIsVisible(false);
      if (onClose) onClose();
    }, 300); // Match animation duration
  }, [onClose]);

  useEffect(() => {
    if (notification) {
      // Slide in
      setIsVisible(true);
      setIsLeaving(false);

      // Auto-dismiss after duration
      const timer = setTimeout(() => {
        handleClose();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [notification, duration, handleClose]);

  if (!notification || !isVisible) return null;

  return (
    <div 
      className={`notification-toast ${isLeaving ? 'leaving' : ''}`}
      onClick={handleClose}
    >
      <div className="notification-icon">
        <span className="notification-badge">🆕</span>
      </div>
      <div className="notification-content">
        <div className="notification-title">New FNOL Received</div>
        <div className="notification-body">
          <strong>FNOL ID:</strong> {notification.fnol_id}
          <br />
          <strong>Claimant:</strong> {notification.claimant || 'Unknown'}
          <br />
          <strong>Cause:</strong> {notification.cause_of_loss}
        </div>
      </div>
      <button 
        className="notification-close"
        onClick={handleClose}
        aria-label="Close notification"
      >
        ×
      </button>
    </div>
  );
};

export default NotificationToast;
